/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  GetMembersSuccessfulActionPayload,
  GetMemberByIdActionPayload,
  GetMemberByIdSuccessfulActionPayload,
  GetActiveMemberWithRelationsByIdActionPayload,
  GetActiveMemberByIdWithRelationsSuccessfulActionPayload,
  CreateMemberActionPayload,
  CreateMemberSuccessfulActionPayload,
  UpdateMemberActionPayload,
  UpdateMemberSuccessfulActionPayload,
  DeleteMemberActionPayload,
  DeleteMemberSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/member-data-store';

/* action types */
export enum ActionTypes {
  InitFetchingActiveMemberWithRelations = '[MEMBER] InitFetchingActiveMemberWithRelations',
  GetMembers = '[MEMBER] GetMembers',
  GetMembersSuccessful = '[MEMBER] GetMembersSuccessful',
  GetActionLogs = '[MEMBER] GetActionLogs',
  GetActionLogsSuccessful = '[MEMBER] GetActionLogsSuccessful',
  GetActionLogsFailure = '[MEMBER] GetActionLogsFailure',
  GetMembersFailure = '[MEMBER] GetMembersFailure',
  GetMemberById = '[MEMBER] GetMemberById',
  GetMemberByIdSuccessful = '[MEMBER] GetMemberByIdSuccessful',
  GetMemberByIdFailure = '[MEMBER] GetMemberByIdFailure',
  GetActiveMemberWithRelationsById = '[MEMBER] GetActiveMemberWithRelationsById',
  GetActiveMemberByIdWithRelationsSuccessful = '[MEMBER] GetActiveMemberByIdWithRelationsSuccessful',
  GetActiveMemberByIdWithRelationsFailure = '[MEMBER] GetActiveMemberByIdWithRelationsFailure',
  CreateMember = '[MEMBER] CreateMember',
  CreateMemberSuccessful = '[MEMBER] CreateMemberSuccessful',
  CreateMemberFailure = '[MEMBER] CreateMemberFailure',
  UpdateMember = '[MEMBER] UpdateMember',
  UpdateMemberSuccessful = '[MEMBER] UpdateMemberSuccessful',
  UpdateMemberFailure = '[MEMBER] UpdateMemberFailure',
  DeleteMember = '[MEMBER] DeleteMember',
  DeleteMemberSuccessful = '[MEMBER] DeleteMemberSuccessful',
  DeleteMemberFailure = '[MEMBER] DeleteMemberFailure',
  ResetState = '[MEMBER] ResetState',
}

/* actions */

export const InitFetchingActiveMemberWithRelations = createAction(
  ActionTypes.InitFetchingActiveMemberWithRelations,
);

/* This event gets the all Members. */
export const GetMembers = createAction(ActionTypes.GetMembers);

/* This event is fired after getting all the Members successfully. */
export const GetMembersSuccessful = createAction(
  ActionTypes.GetMembersSuccessful,
  props<{ payload: GetMembersSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the Members. */
export const GetMembersFailure = createAction(ActionTypes.GetMembersFailure);

export const GetActionLogs = createAction(ActionTypes.GetActionLogs);

export const GetActionLogsSuccessful = createAction(
  ActionTypes.GetActionLogsSuccessful,
  props<{ payload: any }>(),
);

export const GetActionLogsFailure = createAction(
  ActionTypes.GetActionLogsFailure,
);

/* This event gets the Member by Member id. */
export const GetMemberById = createAction(
  ActionTypes.GetMemberById,
  props<{ payload: GetMemberByIdActionPayload }>(),
);

/* This event is fired after getting Member by Member id successfully. */
export const GetMemberByIdSuccessful = createAction(
  ActionTypes.GetMemberByIdSuccessful,
  props<{ payload: GetMemberByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Member by Member id. */
export const GetMemberByIdFailure = createAction(
  ActionTypes.GetMemberByIdFailure,
);

/* This event gets the active Member by Member id. */
export const GetActiveMemberWithRelationsById = createAction(
  ActionTypes.GetActiveMemberWithRelationsById,
  props<{ payload: GetActiveMemberWithRelationsByIdActionPayload }>(),
);

/* This event is fired after getting Member by Member id successfully. */
export const GetActiveMemberByIdWithRelationsSuccessful = createAction(
  ActionTypes.GetActiveMemberByIdWithRelationsSuccessful,
  props<{ payload: GetActiveMemberByIdWithRelationsSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Member by Member id. */
export const GetActiveMemberByIdWithRelationsFailure = createAction(
  ActionTypes.GetActiveMemberByIdWithRelationsFailure,
);

/* This event creates a Member. */
export const CreateMember = createAction(
  ActionTypes.CreateMember,
  props<{ payload: CreateMemberActionPayload }>(),
);

/* This event is fired after creating a Member successfully. */
export const CreateMemberSuccessful = createAction(
  ActionTypes.CreateMemberSuccessful,
  props<{ payload: CreateMemberSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a Member successfully. */
export const CreateMemberFailure = createAction(
  ActionTypes.CreateMemberFailure,
);

/* This event updates a Member. */
export const UpdateMember = createAction(
  ActionTypes.UpdateMember,
  props<{ payload: UpdateMemberActionPayload }>(),
);

/* This event is fired after updating a Member successfully. */
export const UpdateMemberSuccessful = createAction(
  ActionTypes.UpdateMemberSuccessful,
  props<{ payload: UpdateMemberSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a Member successfully. */
export const UpdateMemberFailure = createAction(
  ActionTypes.UpdateMemberFailure,
);

/* This event deletes a Member. */
export const DeleteMember = createAction(
  ActionTypes.DeleteMember,
  props<{ payload: DeleteMemberActionPayload }>(),
);

/* This event is fired after deleting a Member successfully. */
export const DeleteMemberSuccessful = createAction(
  ActionTypes.DeleteMemberSuccessful,
  props<{ payload: DeleteMemberSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a Member successfully. */
export const DeleteMemberFailure = createAction(
  ActionTypes.DeleteMemberFailure,
);

/* This event resets the Member state. */
export const ResetState = createAction(ActionTypes.ResetState);
